<template>
  <td class="pr-4">
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.activities') }}:</strong>
    </h6>
    <span v-for="(activity, index) in activities" :key="index" class="mb-2">
      <el-tag
        style="height: auto; color: black; width: 100%"
        :type="model.enable[index] ? `info` : `danger`"
      >
        <div class="row pt-2">
          <div class="col-12 col-sm-6 col-md-4 col-xl-3">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.name') }}</strong>
            </h6>
            <p class="col-text-ellipsis" v-tooltip.bottom="activity">
              {{ activity }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-1">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.code') }}</strong>
            </h6>
            <p>
              {{ model.code[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6
              class="mb-2 col-text-ellipsis"
              :v-tooltip.bottom="$t('common_words.code_of_homologation')"
            >
              <strong>{{ $t('common_words.approved') }}</strong>
            </h6>
            <p>
              {{ model.homologatedCode[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6
              class="mb-2 col-text-ellipsis"
              v-tooltip.bottom="`Cod. de Centro de Costos`"
            >
              <strong>Centro Costo</strong>
            </h6>
            <p>
              {{ model.costCenter[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.type_capture') }}</strong>
            </h6>
            <p style="text-transform: capitalize">
              {{ model.catchType[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">
              <strong>{{ $t('common_words.payment_unit') }}</strong>
            </h6>
            <p
              class="col-text-ellipsis"
              v-tooltip.bottom="model.payment_unit_names[index]"
            >
              {{ model.payment_unit_names[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">
              {{ $t('common_words.production_unit') }}
            </h6>
            <p
              class="col-text-ellipsis"
              v-tooltip.bottom="model.production_unit_names[index]"
            >
              {{ model.production_unit_names[index] }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">{{ $t('labor.additional_activity') }}?</h6>
            <p class="col-text-ellipsis">
              {{
                model.aditional_activity[index]
                  ? $t('common_words.yes')
                  : $t('common_words.no')
              }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">{{ $t('labor.group_activities') }}?</h6>
            <p class="col-text-ellipsis">
              {{
                model.group_activities[index]
                  ? $t('common_words.yes')
                  : $t('common_words.no')
              }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-xl-2">
            <h6 class="mb-2">{{ $t('labor.assist_control') }}?</h6>
            <p class="col-text-ellipsis">
              {{
                model.assist_control[index]
                  ? $t('common_words.yes')
                  : $t('common_words.no')
              }}
            </p>
          </div>
        </div>
      </el-tag>
    </span>
  </td>
</template>
<script>
export default {
  name: 'info-activities',
  props: {
    activities: {
      type: Array,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
